import { render, staticRenderFns } from "./TestInstruction.vue?vue&type=template&id=7842e802&"
import script from "./TestInstruction.vue?vue&type=script&lang=js&"
export * from "./TestInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports